var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawOnMapLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.75,
    height: 15.75,
    viewBox: "0 0 15.75 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-draw-polygon",
    "data-name": "Icon awesome-draw-polygon",
    d: "M13.5,13.5c-.012,0-.024,0-.036,0l-1.378-2.3a2.17,2.17,0,0,0,0-2.164l1.378-2.3c.012,0,.024,0,.036,0a2.25,2.25,0,1,0-1.938-3.375H4.188A2.243,2.243,0,1,0,1.125,6.438v7.374a2.243,2.243,0,1,0,3.063,3.063h7.374A2.246,2.246,0,1,0,13.5,13.5Zm-10.125.312V6.438a2.244,2.244,0,0,0,.813-.813h7.325L10.161,7.879c-.012,0-.024,0-.036,0a2.25,2.25,0,1,0,0,4.5c.012,0,.024,0,.036,0l1.352,2.254H4.188a2.241,2.241,0,0,0-.813-.813Zm6.188-3.687a.563.563,0,1,1,.563.563A.563.563,0,0,1,9.563,10.125Zm4.5-5.625a.563.563,0,1,1-.562-.562A.563.563,0,0,1,14.063,4.5ZM2.25,3.938a.563.563,0,1,1-.562.563A.563.563,0,0,1,2.25,3.938ZM1.688,15.75a.563.563,0,1,1,.563.563A.563.563,0,0,1,1.688,15.75Zm11.813.563a.563.563,0,1,1,.563-.562A.563.563,0,0,1,13.5,16.313Z",
    transform: "translate(0 -2.25)",
    fill: "#716f6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawOnMapLines);
export default __webpack_public_path__ + "static/media/draw-on-map-lines.e74edfa6de4551f9eeeac188fde2fb59.svg";
export { ForwardRef as ReactComponent };